import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import practiceMode from '../../../../../../images/new-vacation-mode/practice-mode.png';
import pauseMode from '../../../../../../images/new-vacation-mode/pause-mode.png';

const VacationModeModal = ({ 
  open, 
  onClose, 
  setting='goal',
  continueText = "Continue",
  continueLink = "/dashboard/preferences",
  showCancelButton = true,
  cancelText = "Cancel",
  isPaused,
}) => {

  const icon = isPaused ? pauseMode : practiceMode
  const title = isPaused ? "Goal paused" : "Practice mode"
  const message = isPaused ? `To change your ${setting}, you'll need to turn off 'Pause your goal' to continue.` : `To change your ${setting}, you'll need to turn off practice mode to continue.`
  
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent className='avn-modal-content-container'>
        <img src={icon} alt="coaching-icon" />
        <h4>{title}</h4>
        <p>{message}</p>
        <DialogActions className='avn-modal-actions-container'>
          <button className='avn-modal-action' onClick={onClose}>
            {continueText}
          </button>
          {showCancelButton && (
            <button className='avn-modal-action-cancel' onClick={onClose}>
              {cancelText}
            </button>
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default VacationModeModal;
